import { Helmet } from 'react-helmet-async';
import { Route, Routes } from 'react-router-dom';

import ErrorPage from '@/components/errors/ErrorPage';
import { pageTitles } from '@/constants/pageTitles';

import AbsencesCreatePage from './AbsencesCreatePage';
import AbsencesDetailPage from './AbsencesDetailPage';
import AbsencesEditPage from './AbsencesEditPage';
import AbsencesIndexPage from './AbsencesIndexPage';

const AbsencesPage: React.FC = () => (
  <>
    <Helmet>
      <title>{pageTitles.absences}</title>
    </Helmet>
    <Routes>
      <Route path="" element={<AbsencesIndexPage />} />
      <Route path="member" element={<AbsencesIndexPage />} />
      <Route
        path="member/:organizationMembershipId"
        element={<AbsencesIndexPage />}
      />
      <Route
        path="member/:organizationMembershipId/create"
        element={<AbsencesCreatePage />}
      />
      <Route
        path=":absenceId/type/:contactType/edit"
        element={<AbsencesEditPage />}
      />
      <Route
        path=":absenceId/type/:contactType"
        element={<AbsencesDetailPage />}
      />
      <Route path="*" element={<ErrorPage type="not_found" />} />
    </Routes>
  </>
);

export default AbsencesPage;
